import { dateFilter } from '@/utils'

import render from './render'

export default {
  name: 'ReferralsFilter',

  mixins: [ dateFilter ],

  render
}
